import { Injectable } from "@angular/core";
import { BindingURLService } from "../Bindingurlservice/binding-url.service";

@Injectable({
  providedIn: "root",
})
export class LoggingService {
  log: (message?: any, ...optionalParams: any[]) => void;
  error: (message?: any, ...optionalParams: any[]) => void;
  warn: (message?: any, ...optionalParams: any[]) => void;

  constructor(private envService: BindingURLService) {
    if (this.envService.enableLogging) {
      this.log = (message?: any, ...optionalParams: any[]) =>
        console.log(message, ...optionalParams);
      this.error = (message?: any, ...optionalParams: any[]) =>
        console.error(message, ...optionalParams);
      this.warn = (message?: any, ...optionalParams: any[]) =>
        console.warn(message, ...optionalParams);
    } else {
      this.log = () => {};
      this.error = () => {};
      this.warn = () => {};
    }
  }
}
